import React, { useState, useEffect, useContext, useRef } from "react";

import Footer from "../../../components/dashboard/footer";
import Header from "../../../components/dashboard/header";
// import Sidebar from "../../../components/dashboard/sidebar";
import { useNavigate, Link, useLocation } from "react-router-dom";
import axios from 'axios';
import tmdbApi from "../../../api/tmdbApi";
import moment from "moment";
import SweetAlert from "react-bootstrap-sweetalert";
import Modal from 'react-bootstrap/Modal';
import TableLoader from "../../../components/tableLoader";
import DataTable from 'react-data-table-component';
import Loader from "../../../components/loader";

let { lambda, appname } = window.app

const getYouTubeVideoId = (url) => {
    const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    const match = url?.match(regExp);
    return match && match[7].length === 11 ? match[7] : null;
};

// page is saved when opening a CPC so coming back to the Completed tab returns to it
const LIST_POSITION_KEY = "cpcCompletedListPosition";
const DEFAULT_POSITION = { page: 1, perPage: 10 };
const getSavedListPosition = () => {
    try {
        const saved = JSON.parse(localStorage.getItem(LIST_POSITION_KEY));
        return saved?.page && saved?.perPage ? saved : null;
    } catch {
        return null;
    }
};

const Compeletedquiz = ({ restorePosition }) => {
    const navigate = useNavigate()
    const [data, setData] = useState([])
    const [initialPosition] = useState(() => (restorePosition && getSavedListPosition()) || DEFAULT_POSITION);
    const [page, setPage] = useState(initialPosition.page);
    const [perPage, setPerPage] = useState(initialPosition.perPage);
    const [totalRows, setTotalRows] = useState(0);
    const [tableLoading, setTableLoading] = useState(false);
    const requestIdRef = useRef(0);
    const [cpcResult, setCPCResult] = useState([])
    const [anncouncePopup, setAnnouncePopup] = useState(false);
    const [showVideoPopup, setShowVideoPopup] = useState(false);
    const [emailShow, setEmailShow] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const getCpcInfo = async (pageNumber = page, size = perPage, showLoader = true) => {
        const requestId = ++requestIdRef.current;
        showLoader ? setIsLoading(true) : setTableLoading(true);
        try {
            const response = await tmdbApi.cpcInfoAdmin("COMPLETED", pageNumber, size);
            // a newer request went out while this one was in flight - drop this response
            if (requestId !== requestIdRef.current) return;
            const result = response?.result;
            if (result && typeof result === 'object') {
                const rows = Array.isArray(result) ? result : (result?.data ?? []);
                // page is past the end - step back one page
                if (rows.length === 0 && pageNumber > 1) {
                    setPage(pageNumber - 1);
                    getCpcInfo(pageNumber - 1, size, showLoader);
                    return;
                }
                setData(rows);
                setTotalRows(Array.isArray(result) ? rows.length : (result?.totalCount ?? rows.length));
            }
        } catch (error) {
            console.error("Error fetching CPC info:", error);
        }
        if (requestId === requestIdRef.current) {
            setIsLoading(false);
            setTableLoading(false);
        }
    }

    useEffect(() => {
        getCpcInfo(initialPosition.page, initialPosition.perPage)
    }, [])

    const handlePageChange = (newPage) => {
        // the data table re-fires this on mount (React StrictMode) - ignore when nothing changed
        if (newPage === page) return;
        setPage(newPage);
        getCpcInfo(newPage, perPage, false);
    };

    const handlePerRowsChange = (newPerPage) => {
        if (newPerPage === perPage) return;
        setPerPage(newPerPage);
        setPage(1);
        getCpcInfo(1, newPerPage, false);
    };

    const saveListPosition = () => {
        localStorage.setItem(LIST_POSITION_KEY, JSON.stringify({ page, perPage }));
    };

    const handleView = async (row) => {
        console.log(row)
        
        // const response = await tmdbApi.cpcviewResult(row?.cpcid);
        // if (response?.result) {
        //     setCPCResult(response?.result)
        //     setAnnouncePopup(true)
        // }
        saveListPosition()
        navigate("/cpccompletedinfo/" + row.cpcid)
    }

    const handleQuiz = async (row) => {
        saveListPosition()
        navigate("/cpcinfo/" + row.cpcid, {
            state: { caseid: row.cases, cpcid: row.cpcid, routeFrom: "completedQuiz" }
        })
    }

    const dateFormat = (created) => {
        const date = new Date(created);
        // Get individual parts
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = String(date.getFullYear()).slice(-2);
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        // Combine into desired format
        const formattedDate = `${day}-${month}-${year}`;
        return formattedDate
    }

    const cpccolumns = [
        {
            name: 'Participants',
            selector: row => row?.name,
            sortable: false,
        },
        {
            name: 'Score',
            cell: (props) =>
                <div className="d-flex">
                    {props?.score}
                </div>
        },
        {
            name: 'Winner',
            cell: (props) =>
                props?.winner ? <div className="winner">
                    <span className="material-symbols-outlined icon">
                        trophy
                    </span>
                </div> : <></>
        },
    ];

    // Column definitions
    const [editLinkPopup, setEditLinkPopup] = useState(false);
    const [editLinkValue, setEditLinkValue] = useState("");
    const [editRowId, setEditRowId] = useState(null);

    const handleEditLink = (row) => {
        setEditLinkValue(row?.videoLink ?? (row.videoLink || ""));
        setEditRowId(row.cpcid);
        setEditLinkPopup(true);
    };

    const handleSaveLink = async () => {
        const tmp = {
            cpcid: editRowId,
            videoLink: editLinkValue
        }
        try {
            await tmdbApi.updateCpc(JSON.stringify(tmp));
            // Optionally refresh data
            getCpcInfo();
            setEditLinkPopup(false);
        } catch (err) {
            alert("Failed to update link");
        }
    };

    const sendEmail = async (row) => {
        setEmailShow(true);
        setEditRowId(row.cpcid);
    }

    const handleSendEmail = async (e) => {
         // console.log("Sending email for row:", row);
        // You can call your API to send the email here
        try {
            const response = await tmdbApi.sendCpcEmail(editRowId);
            console.log(response);
            setEmailShow(false);
              // Optionally refresh data or show success message
            //getCpcInfo();
            setData(data.map(item =>
                item.cpcid === editRowId ? { ...item, isEmailSent: true } : item
            ));
              // setTimeout(()=>{
            // setEditLinkPopup(false);

            // },500)
        } catch (err) {
            alert("Failed to send email");
        }
    }

    const columns = [
        {
            name: 'Pre-CPC Title',
            selector: row => row.title,
            sortable: true,
        },
        {
            name: 'Meeting Link',
            selector: row => row.meetingLink,
            // selector: row => row.title,
            sortable: true,
        },
        {
            name: 'Meeting Video Link',
            selector: row => row.videoLink,
            cell: row => (
                <span style={{ color: '#007bff', textDecoration: 'underline', cursor: 'pointer' }} onClick={() => handleEditLink(row)}>
                    {/* {row.meetingLink ? row.meetingLink : "Add Meeting Link"} */}
                    {!row.videoLink ? row.videoLink || <div className="upcoming-icons" style={{ display: 'flex' }}>
                        <a className='text-success view-button'><i
                            className="mdi mdi-plus font-size-16"></i>  </a>
                    </div>
                        : row.videoLink}
                </span >
            ),
        },
        {
            name: 'Meeting Date',
            selector: row => row?.meetingDate
                ? moment(row.meetingDate).format("MM-DD-YYYY")
                : "",
        },
        {
            name: 'Start Time',
            selector: row => row.meetingStartTime,
        },
        {
            name: 'End Time',
            selector: row => row.meetingEndTime,
        },
        {
            name: 'Registered',
            selector: row => row?.reservedspots,
            sortable: false,
        },
        {
            name: 'Participated',
            selector: row => row?.participatedCount,
            sortable: false,
        },
        {
            name: 'Email Send',
            selector: row => !row?.isEmailSent && row.videoLink && <div className="upcoming-icons" style={{ display: 'flex' }}>
                <a onClick={() => sendEmail(row)} className='text-success view-button'><i
                    className="mdi mdi-email font-size-16"></i>  </a>
            </div>,
            sortable: false,
        },
        {
            name: 'Cases',
            cell: row => (
                <div className="upcoming-icons" style={{ display: 'flex' }}>
                    <a onClick={() => handleQuiz(row)} className='text-success view-button'><i
                        className="mdi mdi-eye font-size-16"></i>  </a>
                </div>
            ),
        },
        {
            name: 'Results',
            cell: row => (
                <div className="upcoming-icons" style={{ display: 'flex' }}>
                    <a onClick={() => handleView(row)} className='text-success view-button'><i
                        className="mdi mdi-eye font-size-16"></i>  </a>
                </div>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];

    const handleClick = () => {
        navigate('/cpcmanagement');
    };

    const customNoRecords = () => {
        return (
            <div className="empty-state-body empty-record">
                <div className="empty-state__message">
                    <span className="material-icons">summarize</span>
                    <p className="form-check font-size-16">No data found</p>
                </div>
            </div>
        )
    }

    return (
        <>
            {isLoading ? (
                <Loader />
            ) : (
                <div className="cpc-completed">
                    <DataTable
                        key={perPage}
                        columns={columns}
                        data={data}
                        pagination
                        paginationServer
                        paginationTotalRows={totalRows}
                        paginationDefaultPage={page}
                        paginationPerPage={perPage}
                        onChangePage={handlePageChange}
                        onChangeRowsPerPage={handlePerRowsChange}
                        progressPending={tableLoading}
                        progressComponent={<TableLoader />}
                        highlightOnHover
                        striped
                        noDataComponent={customNoRecords()}
                    />
                </div>
            )}

            <Modal className="" show={anncouncePopup}>
                <div className="modal-body enquiry-form">
                    <div className="container">
                        <button className="close-btn" onClick={e => setAnnouncePopup(false)}><span className="material-icons">close</span></button>
                        <DataTable
                            columns={cpccolumns}
                            data={cpcResult}
                            pagination
                            highlightOnHover
                            striped
                            selectableRows={false}
                        />
                    </div>
                </div>
            </Modal>

            {showVideoPopup && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgba(0,0,0,0.8)",
                        zIndex: 1000,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                    onClick={() => setShowVideoPopup(false)}
                >
                    <div style={{ position: "relative", width: "80%", maxWidth: "800px" }}>
                        <iframe
                            width="100%"
                            height="450"
                            src={`https://www.youtube.com/embed/${getYouTubeVideoId(editLinkValue)}`}
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            title="Video Preview"
                        ></iframe>
                        <button className="create-quiz-btn"
                            onClick={() => setShowVideoPopup(false)}
                            style={{
                                position: "absolute",
                                top: 10,
                                right: 10,
                                border: "none",
                                cursor: "pointer",
                            }}
                        >
                            Close
                        </button>
                    </div>
                </div>
            )}

            <Modal show={editLinkPopup} onHide={() => setEditLinkPopup(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Meeting Link</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <input
                        type="text"
                        className="form-control mb-3"
                        value={editLinkValue}
                        onChange={e => setEditLinkValue(e.target.value)}
                        placeholder="Enter meeting link"
                    />
                    <div className="col-lg-12 col-md-12">
                        {getYouTubeVideoId(editLinkValue) && (
                            <div style={{ marginTop: "10px" }}>
                                <iframe
                                    width="100%"
                                    height="450"
                                    src={`https://www.youtube.com/embed/${getYouTubeVideoId(editLinkValue)}`}
                                    title="YouTube Video"
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                    style={{ cursor: "pointer" }}
                                    onClick={() => setShowVideoPopup(true)}
                                />
                                  {/* <p className="d-flex justify-content-start align-items-center gap-2"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => setShowVideoPopup(true)}
                                    >
                                        <span className="material-symbols-outlined">
                                            smart_display
                                        </span> <span className="pre-vid-txt">Preview Video</span>
                                    </p> */}
                            </div>
                        )}

                        {showVideoPopup && (
                            <div
                                style={{
                                    position: "fixed",
                                    top: 0,
                                    left: 0,
                                    width: "100%",
                                    height: "100%",
                                    backgroundColor: "rgba(0,0,0,0.8)",
                                    zIndex: 1000,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                                onClick={() => setShowVideoPopup(false)}
                            >
                                <div style={{ position: "relative", width: "80%", maxWidth: "800px" }}>
                                    <iframe
                                        width="100%"
                                        height="450"
                                        src={`https://www.youtube.com/embed/${getYouTubeVideoId(editLinkValue)}`}
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowFullScreen
                                        title="Video Preview"
                                    ></iframe>
                                    <button className="create-quiz-btn"
                                        onClick={() => setShowVideoPopup(false)}
                                        style={{
                                            position: "absolute",
                                            top: 10,
                                            right: 10,
                                            border: "none",
                                            cursor: "pointer",
                                        }}
                                    >
                                        Close
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-secondary" onClick={() => setEditLinkPopup(false)}>Cancel</button>
                    <button className="btn btn-primary" onClick={handleSaveLink}>Save</button>
                </Modal.Footer>
            </Modal>

            <SweetAlert
                show={emailShow}
                warning
                showCancel
                confirmBtnText="Yes"
                cancelBtnText="Cancel"
                confirmBtnBsStyle="danger"
                cancelBtnBsStyle="default"
                title="Are you sure to send email?"
                focusCancelBtn
                onConfirm={e => handleSendEmail(e)}
                onCancel={e => setEmailShow(false)}
            >
            </SweetAlert>
        </>
    );
};

export default Compeletedquiz;